/* eslint-disable import/no-unused-modules */
export const FBN = 'fbn';
export const FNC = 'FNC';
export const FOX_NATION = 'NATION-DIGITAL';
export const FOX_NATION_QA = 'NATION-DIGITA-QA';
export const FOX_NATION_CHANNEL = 'foxnation';
export const FOX_WEATHER = 'FOXWEATHER';
export const FOXNEWSTALK = 'FOXNEWSTALK';
export const FOXNATIONEVENT = 'FOXNATION-EVENTS';
export const NEWSNOW = 'newsnow';
export const NOW_PLAYING = 'Now Playing';
export const PRIME_TIME_GRID_SCROLL_PREFIX = 'PRIME_TIME_GRID_SCROLL_PREFIX';
export const TILE_IMAGE_LEFT = 'tile-image-left';
